import { useCallback } from "react";
import { MESES } from "../constants";

export const useVPFormatting = (pais, showInDollars, modoCombinado) => {
  const localString = useCallback((p) => ({ Chile: "es-CL", Perú: "es-PE" })[p] || "es-CL", []);

  const moneda = useCallback((p) => ({ Chile: "$ ", Perú: "S/ " })[p] || "$ ", []);

  const getMoneda = useCallback(
    () => (modoCombinado || showInDollars ? "US$ " : moneda(pais)),
    [showInDollars, moneda, pais, modoCombinado]
  );

  const getDisplayValue = useCallback(
    (value) => {
      const locale = localString(pais);
      return value.toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    },
    [pais, localString]
  );

  const getMonthName = useCallback((i) => MESES[i], []);

  const calcularVariacion = useCallback((actual, anterior) => {
    if (!anterior || anterior === 0) return "-";
    return (((actual - anterior) / anterior) * 100).toFixed(0) + "%";
  }, []);

  const shouldShowVsAA = useCallback((year, monthIndex = null, tipo = "cierres") => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonthIdx = currentDate.getMonth();

    // Solo el año en curso oculta el vs-AA de meses futuros (sin cierres aún).
    // Años pasados/futuros y facturación siempre muestran la comparación.
    if (year !== currentYear) return true;
    if (tipo === "facturacion") return true;
    if (monthIndex === null) return true;
    return monthIndex <= currentMonthIdx;
  }, []);

  return {
    localString,
    moneda,
    getMoneda,
    getDisplayValue,
    getMonthName,
    calcularVariacion,
    shouldShowVsAA,
  };
};
